export default function AboutMe() {
  return (
    <section id="AboutMe" className="about--section">
      <div className="about--section--img">
        <img src="./img/about-me.png" alt="About Me" />
      </div>
      <div className="hero--section--content--box about--section--box">
        <div className="hero--section--content">
          <p className="section--title">About</p>
          <h1 className="skills-section--heading">About Me</h1>
          <p className="hero--section-description">
          Hi, I’m Chiranjib Das, a passionate UI/UX Designer and Developer based in Guwahati, Assam. With 1 year of hands-on experience, 
          I specialize in creating intuitive, user-centered digital experiences that combine clean design with functional development. 
          My work bridges creativity and code — using tools like Figma, Adobe XD, React.js, Node.js, and MongoDB — to deliver responsive, engaging, and modern interfaces.
          </p>
          <p className="hero--section-description">
          Having worked with companies like Zola Adventures Ride, Synthweb, Solulab, and Nativebyte, I've designed brand identities, built responsive websites, 
          and developed interactive apps. I’m driven by a deep interest in user empathy and a developer’s eye for detail, always aiming to craft 
          digital products that are not just beautiful but also smart and impactful.

          Let’s build something meaningful together.
          </p>
        </div>
      </div>
    </section>
  );
}
